define('auth/redirect',[], function () {

    var viewmodel = function () {
        var self = this;
        self.compositionComplete = function () {
            location.reload();
        };
    };

    return viewmodel;
});
